function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import deepEqual from 'fast-deep-equal';
import memoize from 'memoize-one';
import { vsLoading, dhGraphLineDown, dhWarningFilled } from '@deephaven/icons';
import { Formatter, FormatterUtils, DateUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { mergeRefs } from '@deephaven/react-hooks';
import { bindAllMethods } from '@deephaven/utils';
import createPlotlyComponent from "./plotly/createPlotlyComponent.js";
import Plotly from "./plotly/Plotly.js";
import ChartModel from "./ChartModel.js";
import ChartErrorOverlay from "./ChartErrorOverlay.js";
import ChartUtils from "./ChartUtils.js";
import "./Chart.css";
import DownsamplingError from "./DownsamplingError.js";
import useChartTheme from "./useChartTheme.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('Chart');

// All of the ChartProps have default values except for model in the Chart
// component, hence the Partial here.

class Chart extends Component {
  /**
   * Convert a font awesome icon definition to a plotly icon definition
   * @param faIcon The icon to convert
   */
  static convertIcon(faIcon) {
    var _faIcon$icon = _slicedToArray(faIcon.icon, 5),
      width = _faIcon$icon[0],
      path = _faIcon$icon[4];
    // By default the icons are flipped upside down, so we need to add our own transform
    // https://github.com/plotly/plotly.js/issues/1335
    var stringPath = "".concat(path);
    return {
      width,
      path: stringPath,
      ascent: width,
      descent: 0,
      transform: "matrix(1, 0, 0, 1, 0, 0)"
    };
  }
  static downsampleButtonTitle(isDownsampleInProgress, isDownsamplingDisabled) {
    if (isDownsampleInProgress) {
      return 'Downsampling in progress...';
    }
    return isDownsamplingDisabled ? 'Downsampling disabled, click to enable' : 'Downsampling enabled, click to disable';
  }
  static downsampleButtonAttr(isDownsampleInProgress, isDownsamplingDisabled) {
    if (isDownsampleInProgress) {
      return 'animation-spin';
    }
    return isDownsamplingDisabled ? undefined : 'fill-active';
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "currentSeries", void 0);
    _defineProperty(this, "PlotComponent", void 0);
    _defineProperty(this, "plot", void 0);
    _defineProperty(this, "plotWrapper", void 0);
    _defineProperty(this, "plotWrapperMerged", void 0);
    _defineProperty(this, "columnFormats", void 0);
    _defineProperty(this, "dateTimeFormatterOptions", void 0);
    _defineProperty(this, "decimalFormatOptions", void 0);
    _defineProperty(this, "integerFormatOptions", void 0);
    _defineProperty(this, "webgl", void 0);
    _defineProperty(this, "plotElement", null);
    _defineProperty(this, "rect", void 0);
    _defineProperty(this, "ranges", void 0);
    _defineProperty(this, "isSubscribed", void 0);
    _defineProperty(this, "isLoadedFired", void 0);
    // Listen for resizing of the element and update the canvas appropriately
    _defineProperty(this, "resizeObserver", void 0);
    _defineProperty(this, "getCachedConfig", memoize((downsamplingError, isDownsampleFinished, isDownsampleInProgress, isDownsamplingDisabled, data, error, hasSelectionCallbacks) => {
      var customButtons = [];
      var hasDownsampleError = Boolean(downsamplingError);
      if (hasDownsampleError) {
        customButtons.push({
          name: "Downsampling failed: ".concat(downsamplingError),
          title: 'Downsampling failed',
          click: () => {
            this.toggleErrorMessage("".concat(downsamplingError));
          },
          icon: Chart.convertIcon(dhWarningFilled),
          attr: 'fill-warning'
        });
      }
      var hasError = Boolean(error);
      if (hasError) {
        customButtons.push({
          name: "Error: ".concat(error),
          title: "Error",
          click: () => {
            this.toggleErrorMessage("".concat(error));
          },
          icon: Chart.convertIcon(dhWarningFilled),
          attr: 'fill-warning'
        });
      }
      if (isDownsampleFinished || isDownsampleInProgress || isDownsamplingDisabled || hasDownsampleError) {
        var name = Chart.downsampleButtonTitle(isDownsampleInProgress, isDownsamplingDisabled);
        var attr = Chart.downsampleButtonAttr(isDownsampleInProgress, isDownsamplingDisabled);
        var icon = isDownsampleInProgress ? vsLoading : dhGraphLineDown;
        customButtons.push({
          name,
          title: 'Downsampling status',
          icon: Chart.convertIcon(icon),
          click: this.handleDownsampleClick,
          attr
        });
      }
      var has2D = data.some(_ref => {
        var type = _ref.type;
        return type != null && !type.includes('3d');
      });
      var has3D = data.some(_ref2 => {
        var type = _ref2.type;
        return type != null && type.includes('3d');
      });

      // zoom2d and pan2d work for both 2D and 3D charts
      var interactionButtons = ['zoom2d', 'pan2d', ...(hasSelectionCallbacks && has2D ? ['select2d', 'lasso2d'] : [])];
      var dimensionButtons = [...(has2D ? ['zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d'] : []), ...(has3D ? ['orbitRotation', 'tableRotation', 'resetCameraDefault3d'] : [])];

      // Display the mode bar persistently if there's an error or downsampling so user can see progress
      // Yes, the value is a boolean or the string 'hover': https://github.com/plotly/plotly.js/blob/master/src/plot_api/plot_config.js#L249
      var alwaysShowModeBar =
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      isDownsampleInProgress || hasDownsampleError || hasError;
      return {
        displaylogo: false,
        // scales the plot to the container size
        // https://github.com/plotly/react-plotly.js/issues/102
        responsive: true,
        displayModeBar: alwaysShowModeBar ? true : 'hover',
        // Each array gets grouped together in the mode bar
        modeBarButtons: [customButtons, ['toImage'], interactionButtons, dimensionButtons]
      };
    }));
    bindAllMethods(this);
    this.PlotComponent = createPlotlyComponent(props.Plotly);
    this.plot = /*#__PURE__*/React.createRef();
    this.plotWrapper = /*#__PURE__*/React.createRef();
    this.plotWrapperMerged = mergeRefs(this.plotWrapper, props.containerRef);
    this.columnFormats = [];
    this.dateTimeFormatterOptions = {};
    this.decimalFormatOptions = {};
    this.integerFormatOptions = {};
    this.isSubscribed = false;
    this.isLoadedFired = false;
    this.currentSeries = 0;
    this.resizeObserver = new window.ResizeObserver(this.handleResize);
    this.state = {
      data: null,
      downsamplingError: null,
      isDownsampleFinished: false,
      isDownsampleInProgress: false,
      isDownsamplingDisabled: false,
      error: null,
      shownError: null,
      layout: {
        datarevision: 0
      },
      revision: 0,
      shownBlocker: null
    };
  }
  componentDidMount() {
    // Need to make sure the model dimensions are up to date before initializing the data
    this.updateDimensions();
    this.updateModelDimensions();
    this.initData();
    this.initFormatter();
    var _this$props = this.props,
      isActive = _this$props.isActive,
      model = _this$props.model;
    if (isActive) {
      this.subscribe(model);
    }
    if (this.plotWrapper.current != null) {
      this.resizeObserver.observe(this.plotWrapper.current);
    }
    this.handleThemeChange();
  }
  componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
      isActive = _this$props2.isActive,
      model = _this$props2.model,
      settings = _this$props2.settings,
      theme = _this$props2.theme,
      onPlotElementChange = _this$props2.onPlotElementChange;
    this.updateFormatterSettings(settings);
    if (model !== prevProps.model) {
      var _prevProps$onPlotElem;
      (_prevProps$onPlotElem = prevProps.onPlotElementChange) === null || _prevProps$onPlotElem === void 0 || _prevProps$onPlotElem.call(prevProps, null);
      this.unsubscribe(prevProps.model);
      onPlotElementChange === null || onPlotElementChange === void 0 || onPlotElementChange(this.plotElement);
      this.subscribe(model);
    }
    if (isActive !== prevProps.isActive) {
      if (isActive) {
        this.updateDimensions();
        this.subscribe(model);
      } else {
        this.unsubscribe(model);
      }
    }
    if (theme !== prevProps.theme) {
      this.handleThemeChange();
    }
  }
  componentWillUnmount() {
    var model = this.props.model;
    this.unsubscribe(model);
    this.resizeObserver.disconnect();
  }
  getPlotRect() {
    var _this$plotWrapper$cur, _this$plotWrapper$cur2;
    return (_this$plotWrapper$cur = (_this$plotWrapper$cur2 = this.plotWrapper.current) === null || _this$plotWrapper$cur2 === void 0 ? void 0 : _this$plotWrapper$cur2.getBoundingClientRect()) !== null && _this$plotWrapper$cur !== void 0 ? _this$plotWrapper$cur : null;
  }
  initData() {
    var model = this.props.model;
    this.setState(_ref3 => {
      var layout = _ref3.layout;
      return {
        data: model.getData(),
        layout: _objectSpread(_objectSpread({}, layout), model.getLayout())
      };
    });
  }
  subscribe(model) {
    if (this.isSubscribed) {
      return;
    }
    if (!this.rect || this.rect.width === 0 || this.rect.height === 0) {
      log.debug2('Delaying subscription until model dimensions are set');
      return;
    }
    model.subscribe(this.handleModelEvent);
    this.isSubscribed = true;
  }
  unsubscribe(model) {
    if (!this.isSubscribed) {
      return;
    }
    model.unsubscribe(this.handleModelEvent);
    this.isSubscribed = false;
  }
  handleAfterPlot() {
    if (this.plot.current != null) {
      // TODO: Translate whatever Don was doing in plotting.js in the afterplot here so that area graphs show up properly
    }
  }
  handlePlotInitialized(_figure, graphDiv) {
    // Provide the actual Plotly graph div to consumers so they can attach
    // imperative event listeners (needed for some events that Plotly doesn't
    // support in react-plotly.js)
    this.plotElement = graphDiv;
    var onPlotElementChange = this.props.onPlotElementChange;
    onPlotElementChange === null || onPlotElementChange === void 0 || onPlotElementChange(graphDiv);
  }
  handlePlotPurge() {
    this.plotElement = null;
    var onPlotElementChange = this.props.onPlotElementChange;
    onPlotElementChange === null || onPlotElementChange === void 0 || onPlotElementChange(null);
  }
  handleDownsampleClick() {
    this.setState(_ref4 => {
      var isDownsamplingDisabled = _ref4.isDownsamplingDisabled;
      return {
        downsamplingError: null,
        isDownsampleInProgress: false,
        isDownsampleFinished: false,
        isDownsamplingDisabled: !isDownsamplingDisabled
      };
    }, () => {
      var model = this.props.model;
      var isDownsamplingDisabled = this.state.isDownsamplingDisabled;
      model.setDownsamplingDisabled(isDownsamplingDisabled);
    });
  }
  handleErrorClose() {
    this.setState({
      shownError: null
    });
  }
  handleDownsampleErrorClose() {
    this.setState({
      downsamplingError: null
    });
  }
  handleModelEvent(event) {
    var type = event.type,
      detail = event.detail;
    log.debug2('Received data update', type, detail);
    switch (type) {
      case ChartModel.EVENT_UPDATED:
        {
          this.currentSeries += 1;
          this.setState(state => {
            var layout = state.layout,
              revision = state.revision;
            if (typeof layout.datarevision === 'number') {
              layout.datarevision += 1;
            }
            return {
              data: detail,
              layout,
              revision: revision + 1
            };
          });
          var onUpdate = this.props.onUpdate;
          onUpdate({
            isLoading: !this.isLoadedFired
          });
          break;
        }
      case ChartModel.EVENT_LOADFINISHED:
        {
          var _onUpdate = this.props.onUpdate;
          this.isLoadedFired = true;
          _onUpdate({
            isLoading: false
          });
          break;
        }
      case ChartModel.EVENT_DISCONNECT:
        {
          var onDisconnect = this.props.onDisconnect;
          onDisconnect();
          break;
        }
      case ChartModel.EVENT_RECONNECT:
        {
          var onReconnect = this.props.onReconnect;
          onReconnect();
          break;
        }
      case ChartModel.EVENT_DOWNSAMPLESTARTED:
        {
          this.setState({
            isDownsampleFinished: false,
            isDownsampleInProgress: true,
            downsamplingError: null
          });
          break;
        }
      case ChartModel.EVENT_DOWNSAMPLEFINISHED:
        {
          this.setState({
            isDownsampleFinished: true,
            isDownsampleInProgress: false,
            downsamplingError: null
          });
          break;
        }
      case ChartModel.EVENT_DOWNSAMPLENEEDED:
      case ChartModel.EVENT_DOWNSAMPLEFAILED:
        {
          var _message;
          var downsamplingError = (_message = detail.message) !== null && _message !== void 0 ? _message : detail;
          this.setState({
            isDownsampleFinished: false,
            isDownsampleInProgress: false,
            isDownsamplingDisabled: false,
            downsamplingError
          });
          var onError = this.props.onError;
          onError(new DownsamplingError(downsamplingError == null ? undefined : "".concat(downsamplingError)));
          break;
        }
      case ChartModel.EVENT_ERROR:
        {
          var error = "".concat(detail);
          this.setState({
            error
          });
          var _onError = this.props.onError;
          _onError(new Error(error));
          break;
        }
      case ChartModel.EVENT_BLOCKER:
        {
          var blocker = "".concat(detail);
          this.setState({
            shownBlocker: blocker
          });
          break;
        }
      case ChartModel.EVENT_BLOCKER_CLEAR:
        {
          this.setState({
            shownBlocker: null
          });
          break;
        }
      case ChartModel.EVENT_LAYOUT_UPDATED:
        {
          var newLayout = detail;
          this.setState(_ref5 => {
            var layout = _ref5.layout,
              revision = _ref5.revision;
            return {
              layout: _objectSpread(_objectSpread({}, layout), newLayout),
              revision: revision + 1
            };
          });
          break;
        }
      default:
        log.debug('Unknown event type', type, event);
    }
  }
  handlePlotUpdate(figure) {
    // User could have modified zoom/pan here, update the model dimensions
    // We don't need to update the datarevision, as we don't have any data changes
    // until an update comes back from the server anyway
    var layout = figure.layout;
    var ranges = ChartUtils.getLayoutRanges(layout);
    var isRangesChanged = !deepEqual(ranges, this.ranges);
    if (isRangesChanged) {
      this.ranges = ranges;
      this.updateModelDimensions(true);
    }
  }
  handleRelayout(changes) {
    log.debug('handleRelayout', changes);
    if (changes.hiddenlabels != null) {
      var onSettingsChanged = this.props.onSettingsChanged;
      // Pie charts store series visibility in layout.hiddenlabels and trigger relayout on changes
      // Series visibility for other types of charts is handled in handleRestyle
      var hiddenSeries = [...changes.hiddenlabels];
      onSettingsChanged({
        hiddenSeries
      });
    }
    this.updateModelDimensions();
    var onPlotlyRelayout = this.props.onPlotlyRelayout;
    onPlotlyRelayout === null || onPlotlyRelayout === void 0 || onPlotlyRelayout(changes);
  }
  handleClick(data) {
    var onPlotlyClick = this.props.onPlotlyClick;
    onPlotlyClick === null || onPlotlyClick === void 0 || onPlotlyClick(data);
  }
  handleDoubleClick() {
    var onPlotlyDoubleClick = this.props.onPlotlyDoubleClick;
    onPlotlyDoubleClick === null || onPlotlyDoubleClick === void 0 || onPlotlyDoubleClick();
  }
  handleSelected(data) {
    var onPlotlySelected = this.props.onPlotlySelected;
    onPlotlySelected === null || onPlotlySelected === void 0 || onPlotlySelected(data);
  }
  handleDeselect() {
    var onPlotlyDeselect = this.props.onPlotlyDeselect;
    onPlotlyDeselect === null || onPlotlyDeselect === void 0 || onPlotlyDeselect();
  }
  handleClickAnnotation(data) {
    var onPlotlyClickAnnotation = this.props.onPlotlyClickAnnotation;
    onPlotlyClickAnnotation === null || onPlotlyClickAnnotation === void 0 || onPlotlyClickAnnotation(data);
  }
  handleLegendClick(data) {
    var _onPlotlyLegendClick;
    var onPlotlyLegendClick = this.props.onPlotlyLegendClick;
    return (_onPlotlyLegendClick = onPlotlyLegendClick === null || onPlotlyLegendClick === void 0 ? void 0 : onPlotlyLegendClick(data)) !== null && _onPlotlyLegendClick !== void 0 ? _onPlotlyLegendClick : true;
  }
  handleLegendDoubleClick(data) {
    var _onPlotlyLegendDouble;
    var onPlotlyLegendDoubleClick = this.props.onPlotlyLegendDoubleClick;
    return (_onPlotlyLegendDouble = onPlotlyLegendDoubleClick === null || onPlotlyLegendDoubleClick === void 0 ? void 0 : onPlotlyLegendDoubleClick(data)) !== null && _onPlotlyLegendDouble !== void 0 ? _onPlotlyLegendDouble : true;
  }
  handleWebGlContextLost() {
    var onPlotlyWebGlContextLost = this.props.onPlotlyWebGlContextLost;
    onPlotlyWebGlContextLost === null || onPlotlyWebGlContextLost === void 0 || onPlotlyWebGlContextLost();
  }
  handleResize() {
    this.updateDimensions();
  }
  handleRestyle(_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      changes = _ref7[0],
      seriesIndexes = _ref7[1];
    log.debug('handleRestyle', changes, seriesIndexes);
    if (Object.keys(changes).includes('visible')) {
      var data = this.state.data;
      var onSettingsChanged = this.props.onSettingsChanged;
      if (data != null) {
        var hiddenSeries = data.reduce((acc, _ref8) => {
          var name = _ref8.name,
            visible = _ref8.visible;
          return name != null && visible === 'legendonly' ? [...acc, name] : acc;
        }, []);
        onSettingsChanged({
          hiddenSeries
        });
      }
    }
  }
  handleThemeChange() {
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      model = _this$props3.model;
    var dh = model.dh;
    var chartUtils = new ChartUtils(dh);
    this.setState(_ref9 => {
      var layout = _ref9.layout;
      return {
        layout: _objectSpread(_objectSpread({}, layout), {}, {
          template: chartUtils.makeDefaultTemplate(theme)
        })
      };
    });
  }

  /**
   * Toggle the error message. If it is already being displayed, then hide it.
   */
  toggleErrorMessage(error) {
    this.setState(_ref0 => {
      var shownError = _ref0.shownError;
      return {
        shownError: shownError === error ? null : error
      };
    });
  }

  /**
   * Update the models dimensions and ranges.
   * Note that this will update it all whether the plot size changes OR the range
   * the user is looking at has changed (eg. panning/zooming).
   * Could update each independently, but doing them at the same time keeps the
   * ChartModel API a bit cleaner.
   * @param force Force a change even if the chart dimensions haven't changed (eg. after pan/zoom)
   */
  updateModelDimensions() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var rect = this.getPlotRect();
    if (!rect) {
      log.warn('Unable to get plotting rect');
      return;
    }
    var isRectChanged = !this.rect || this.rect.width !== rect.width || this.rect.height !== rect.height;
    if (isRectChanged || force) {
      this.rect = rect;
      var _this$props4 = this.props,
        isActive = _this$props4.isActive,
        model = _this$props4.model;
      model.setDimensions(rect);
      // We may need to resubscribe if dimensions were too small before
      if (isActive) {
        this.subscribe(model);
      }
    }
  }
  initFormatter() {
    var settings = this.props.settings;
    this.updateFormatterSettings(settings);
  }
  updateFormatterSettings(settings) {
    var columnFormats = FormatterUtils.getColumnFormats(settings);
    var dateTimeFormatterOptions = FormatterUtils.getDateTimeFormatterOptions(settings);
    var _settings$defaultDeci = settings.defaultDecimalFormatOptions,
      defaultDecimalFormatOptions = _settings$defaultDeci === void 0 ? {} : _settings$defaultDeci,
      _settings$defaultInte = settings.defaultIntegerFormatOptions,
      defaultIntegerFormatOptions = _settings$defaultInte === void 0 ? {} : _settings$defaultInte;
    if (!deepEqual(this.columnFormats, columnFormats) || !deepEqual(this.dateTimeFormatterOptions, dateTimeFormatterOptions) || !deepEqual(this.decimalFormatOptions, defaultDecimalFormatOptions) || !deepEqual(this.integerFormatOptions, defaultIntegerFormatOptions)) {
      this.columnFormats = FormatterUtils.getColumnFormats(settings);
      this.dateTimeFormatterOptions = dateTimeFormatterOptions;
      this.decimalFormatOptions = defaultDecimalFormatOptions;
      this.integerFormatOptions = defaultIntegerFormatOptions;
      this.updateFormatter();
    }
    if (this.webgl !== settings.webgl) {
      this.webgl = settings.webgl;
      this.updateRenderOptions();
    }
  }
  updateFormatter() {
    var model = this.props.model;
    var formatter = new Formatter(model.dh, this.columnFormats, this.dateTimeFormatterOptions, this.decimalFormatOptions, this.integerFormatOptions);
    model.setFormatter(formatter);
  }
  updateRenderOptions() {
    var model = this.props.model;
    var renderOptions = {
      webgl: this.webgl
    };
    model.setRenderOptions(renderOptions);
  }
  updateDimensions() {
    var rect = this.getPlotRect();
    var PlotlyProp = this.props.Plotly;
    if (this.plot.current != null && rect != null && rect.width > 0 && rect.height > 0) {
      // Call relayout to resize avoiding the debouncing plotly does
      // https://github.com/plotly/plotly.js/issues/2769#issuecomment-402099552
      PlotlyProp.relayout(this.plot.current.el, {
        autosize: true
      }).catch(e => {
        log.debug('Unable to resize, promise rejected', e);
      });
    }
  }
  render() {
    var PlotComponent = this.PlotComponent;
    var _this$state = this.state,
      data = _this$state.data,
      downsamplingError = _this$state.downsamplingError,
      isDownsampleFinished = _this$state.isDownsampleFinished,
      isDownsampleInProgress = _this$state.isDownsampleInProgress,
      isDownsamplingDisabled = _this$state.isDownsamplingDisabled,
      error = _this$state.error,
      shownError = _this$state.shownError,
      layout = _this$state.layout,
      revision = _this$state.revision,
      shownBlocker = _this$state.shownBlocker;
    var model = this.props.model;
    var config = this.getCachedConfig(downsamplingError, isDownsampleFinished, isDownsampleInProgress, isDownsamplingDisabled, data !== null && data !== void 0 ? data : [], error, model.hasSelectionCallbacks());
    var isPlotShown = data != null && shownBlocker == null;
    var errorOverlay = null;
    if (shownBlocker != null) {
      errorOverlay = /*#__PURE__*/_jsx(ChartErrorOverlay, {
        errorMessage: "".concat(shownBlocker),
        onConfirm: () => {
          model.fireBlockerClear();
        }
      });
    } else if (shownError != null) {
      errorOverlay = /*#__PURE__*/_jsx(ChartErrorOverlay, {
        errorMessage: "".concat(downsamplingError),
        onDiscard: () => {
          this.handleDownsampleErrorClose();
        },
        onConfirm: () => {
          this.handleDownsampleErrorClose();
          this.handleDownsampleClick();
        }
      });
    } else if (downsamplingError != null) {
      errorOverlay = /*#__PURE__*/_jsx(ChartErrorOverlay, {
        errorMessage: "".concat(downsamplingError),
        onDiscard: () => {
          this.handleDownsampleErrorClose();
        },
        onConfirm: () => {
          this.handleDownsampleErrorClose();
          this.handleDownsampleClick();
        }
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "h-100 w-100 chart-wrapper",
      ref: this.plotWrapperMerged,
      children: [isPlotShown && /*#__PURE__*/_jsx(PlotComponent
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      , {
        ref: this.plot,
        data: data,
        layout: layout,
        revision: revision,
        config: config,
        onAfterPlot: this.handleAfterPlot,
        onError: log.error,
        onInitialized: this.handlePlotInitialized,
        onPurge: this.handlePlotPurge,
        onRelayout: this.handleRelayout,
        onUpdate: this.handlePlotUpdate,
        onRestyle: this.handleRestyle,
        onClick: this.handleClick,
        onDoubleClick: this.handleDoubleClick,
        onSelected: this.handleSelected,
        onDeselect: this.handleDeselect,
        onClickAnnotation: this.handleClickAnnotation,
        onLegendClick: this.handleLegendClick,
        onLegendDoubleClick: this.handleLegendDoubleClick,
        onWebGlContextLost: this.handleWebGlContextLost,
        style: {
          height: '100%',
          width: '100%'
        }
      }), errorOverlay]
    });
  }
}
_defineProperty(Chart, "defaultProps", {
  isActive: true,
  settings: {
    timeZone: 'America/New_York',
    defaultDateTimeFormat: DateUtils.FULL_DATE_FORMAT,
    showTimeZone: false,
    showTSeparator: true,
    formatter: [],
    webgl: true
  },
  Plotly,
  onDisconnect: () => undefined,
  onReconnect: () => undefined,
  onUpdate: () => undefined,
  onError: () => undefined,
  onSettingsChanged: () => undefined
});
export default function ChartContainer(props) {
  var chartTheme = useChartTheme();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/_jsx(Chart, _objectSpread(_objectSpread({}, props), {}, {
    theme: chartTheme
  }));
}
//# sourceMappingURL=Chart.js.map